import { render } from "./footer.component.vue?vue&type=template&id=435a921a&ts=true"
import script from "./footer.component.vue?vue&type=script&lang=ts"
export * from "./footer.component.vue?vue&type=script&lang=ts"

import "./footer.component.vue?vue&type=style&index=0&id=435a921a&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__